export const fetchRoutingTable = async () => {
    try {
        const routingTableUrl = process.env["ROUTING_TABLE_URL"] as string;
        const response = await fetch(routingTableUrl);
        if (!response.ok) {
            throw new Error(
                `Failed to fetch Routing Table from CloudFront: ${response.status} ${response.statusText}`
            );
        }
        return await response.json();
    } catch (error) {
        console.error("Error fetching Routing Table", error);
    }
};

export const inRoutingTable = (
    segments: string[],
    index: number,
    segLength: number,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    routeObject: any
): boolean => {
    const currSeg = String(segments[index]);
    const hasSeg = routeObject[currSeg];
    const hasWildcard = routeObject["*"];
    const lastSeg = index == segLength;

    let hasSegResult = false;
    let hasWildcardResult = false;

    if (hasSeg) {
        if (lastSeg) {
            hasSegResult = !Boolean(hasSeg["p"]);
        } else {
            hasSegResult = inRoutingTable(
                segments,
                index + 1,
                segLength,
                hasSeg
            );
        }
    }

    if (hasWildcard) {
        if (lastSeg) {
            hasWildcardResult = !Boolean(hasWildcard["p"]);
        } else {
            hasWildcardResult = inRoutingTable(
                segments,
                index + 1,
                segLength,
                hasWildcard
            );
        }
    }

    return hasSegResult || hasWildcardResult;
};
